module.exports = __webpack_public_path__ + "static/media/bed-bg.93d2b245.svg";